<script>
    export let respondents;
    export let summary;
    export let fillTotal;
    let circleWidth = 20;
    let totalPerRow = 15;

    function getStyle(i,fillTotal){
        //if(i.answersyes){
  
            if( i < fillTotal ){
                return 'response-1'
            } else {
                return 'response-2'
            }


        //}
    }

</script>

<p class='summary'>{summary}</p>
<svg viewbox='0 0 {circleWidth * totalPerRow} {Math.ceil(respondents/totalPerRow) * circleWidth}'>
    <g style="transform: translate({ (respondents < totalPerRow) ? (totalPerRow-respondents)/2 * circleWidth: 0 }px,0px);">
    {#each new Array(Number(respondents)) as c, i}
        <circle
            r='{(circleWidth-4)/2}'
            cx='{circleWidth/2 + (i%totalPerRow)*circleWidth }'
            cy='{circleWidth/2 +Math.floor(i/totalPerRow)*circleWidth}'
            class='response {getStyle(i,fillTotal)}'
            ></circle>
    {/each}
    </g>
</svg>